<template>
  <b-card no-body>
    <b-card-body class="d-flex align-items-center">
      <b-avatar
        :variant="`light-${color}`"
        size="45"
      >
        <feather-icon
          size="21"
          :icon="icon"
        />
      </b-avatar>
      <div class="truncate ml-2">
        <h2 class="mb-25 font-weight-bolder">
          {{ statistic }} {{ prefix }}
        </h2>
        <span>{{ statisticTitle }}</span>
      </div>

    </b-card-body>
  </b-card>
</template>

<script>
import { BCard, BCardBody, BAvatar } from 'bootstrap-vue'

export default {
  components: {
    BCard,
    BCardBody,
    BAvatar,
  },
  props: {
    icon: {
      type: String,
      required: true,
    },
    statistic: {
      type: [Number, String],
      default: '0',
    },
    statisticTitle: {
      type: String,
      default: '',
    },
    color: {
      type: String,
      default: 'primary',
    },
    prefix: {
      type: String,
      default: '',
    },
  },
}
</script>
